import React, { useContext } from "react";
import styled from "styled-components";
import { UIContext } from "../../contexts/UIContext";

const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 40px;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
function KickPredictor({ game, previewGraphic, player, skyData }) {
  const { useSkyData, showKickToCome } = useContext(UIContext);
  let kicks = [];
  if (useSkyData) {
    try {
      kicks = skyData?.filter(
        (k) =>
          k?.Player?.ProviderId === player?.opta_ID
      );
    } catch (err) {}
  } else {
    try {
      if (
        Array.isArray(game?.kick_predictor?.teams?.team?.[0]?.goalKickEvent)
      ) {
        kicks = kicks.concat(
          game?.kick_predictor?.teams?.team?.[0]?.goalKickEvent,
        );
      } else {
        kicks.push(game?.kick_predictor?.teams?.team?.[0]?.goalKickEvent);
      }
      if (
        Array.isArray(game?.kick_predictor?.teams?.team?.[1]?.goalKickEvent)
      ) {
        kicks = kicks.concat(
          game?.kick_predictor?.teams?.team?.[1]?.goalKickEvent,
        );
      } else {
        kicks.push(game?.kick_predictor?.teams?.team?.[1]?.goalKickEvent);
      }
      kicks = kicks
        ?.filter((k) => {
          return k?.player_id === player?.opta_ID;
        })
        ?.sort((a, b) => {
          if (a?.period === "First Half" && b?.period === "Second Half") {
            return 1;
          }
          if (a?.period === "Second Half" && b?.period === "First Half") {
            return -1;
          }
          if (parseInt(a?.time) < parseInt(b?.time)) {
            return 1;
          }
          if (parseInt(a?.time) > parseInt(b?.time)) {
            return -1;
          }
          if (parseInt(a?.secs) < parseInt(b?.secs)) {
            return 1;
          }
          if (parseInt(a?.secs) > parseInt(b?.secs)) {
            return -1;
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  let scorers = (game?.home_scorers || [])?.concat(game?.away_scorers || []);
  let made =
    scorers?.filter((g) => {
      return (
        g.player &&
        player.squad &&
        g?.player === player?.squad?._id &&
        (g?.type === "conversion" || g?.type === "penalty_kick")
      );
    })?.length || 0;
  let missed =
    scorers?.filter((g) => {
      return (
        g.player &&
        player.squad &&
        g?.player === player?.squad?._id &&
        (g?.type === "missed_conversion" || g?.type === "missed_penalty_kick")
      );
    })?.length || 0;

  return (
    <>
      {kicks?.slice(0, 1)?.map((kick) => {
        return (
          <>
            <GraphicButton
              onClick={() => {
                previewGraphic("Name", {
                  player: player,
                  subtext: useSkyData
                    ? "Distance: " +
                      kick?.distance +
                      "     Angle: " +
                      kick?.angle +
                      "     Success probability: " +
                      kick?.playerProb
                    : "Distance: " +
                      Math.floor(kick?.distance) +
                      "m     Angle: " +
                      Math.floor(kick?.angle) +
                      "°     Success probability: " +
                      Math.floor(kick?.playerProb * 100) +
                      "%",

                  team: player?.team,
                  game,
                  show_number: true,
                });
              }}
            >
              <div>
                <Column>
                  <div>Kick metrics L3</div>
                  {useSkyData && (
                    <div>{kick?.distance + " - " + kick?.angle}</div>
                  )}
                  {!useSkyData && (
                    <div>
                      {kick?.time?.toString()?.padStart(2, "0")}:
                      {kick?.secs?.toString()?.padStart(2, "0")} -{" "}
                      {kick?.statname ?? kick?.StatName}
                    </div>
                  )}
                </Column>
              </div>
            </GraphicButton>
            </>
        )})}
        {kicks?.filter(k=>k.KickToCome)?.map(kick => {
           return ( <>
            <GraphicButton
              onClick={() => {
                previewGraphic("KickPredictorGauge", {
                  player: player,
                  percent: useSkyData
                    ? kick.playerProb?.replace("%", "")
                    : Math.floor(kick?.playerProb * 100),
                  team: player?.team,
                  game,
                  show_number: true,
                  made,
                  missed,
                });
              }}
            >
              <div>
                <Column>
                  <div>Kick success % gauge</div>
                  {useSkyData && (
                    <div>
                      {kick.playerProb}% - Goals {made}/{missed + made} (
                      {made + missed > 0
                        ? ((made / (made + missed)) * 100)?.toFixed(0)
                        : "0"}
                      %
                    </div>
                  )}
                  {!useSkyData && (
                    <div>
                      {kick?.time?.toString()?.padStart(2, "0")}:
                      {kick?.secs?.toString()?.padStart(2, "0")} -{" "}
                      {Math.floor(kick?.playerProb * 100)}% - Goals {made}/
                      {missed + made} (
                      {made + missed > 0
                        ? ((made / (made + missed)) * 100)?.toFixed(0)
                        : "0"}
                      %)
                    </div>
                  )}
                  <div>{kick?.statname ?? kick?.StatName}</div>
                </Column>
              </div>
            </GraphicButton>
            <GraphicButton
              onClick={() => {
                let scorers = (game?.home_scorers || [])?.concat(
                  game?.away_scorers || [],
                );
                let made =
                  scorers?.filter((g) => {
                    return (
                      g.player &&
                      player.squad &&
                      g?.player === player?.squad?._id &&
                      (g?.type === "conversion" || g?.type === "penalty_kick")
                    );
                  })?.length || 0;
                let missed =
                  scorers?.filter((g) => {
                    return (
                      g.player &&
                      player.squad &&
                      g?.player === player?.squad?._id &&
                      (g?.type === "missed_conversion" ||
                        g?.type === "missed_penalty_kick")
                    );
                  })?.length || 0;

                previewGraphic("KickPredictorGauge", {
                  player: player,
                  percent: useSkyData
                    ? kick.playerProb?.replace("%", "")
                    : Math.floor(kick?.playerProb * 100),
                  team: player?.team,
                  game,
                  show_number: true,
                  made: 0,
                  missed: 0,
                });
              }}
            >
              <div>
                <Column>
                  <div>Kick success % gauge</div>
                  {useSkyData && (
                    <div>{kick.playerProb} - No kick succ. subline</div>
                  )}
                  {!useSkyData && (
                    <div>
                      {kick?.time?.toString()?.padStart(2, "0")}:
                      {kick?.secs?.toString()?.padStart(2, "0")} - No kick succ.
                      subline
                    </div>
                  )}
                </Column>
              </div>
            </GraphicButton>
          </>
        );
      })}
      {kicks?.length > 0 && 
        <GraphicButton
              onClick={() => {
                previewGraphic("KickMap", {
                  player: player,
                  team: player?.team,
                  game,
                  kicks
                });
              }}
            >
             Kick Map ({kicks?.[0]?.KickToCome ? 'Kick to come' : kicks?.[0]?.statname !== undefined ? kicks?.[0]?.statname : kicks?.[0]?.StatName })
        </GraphicButton>
}
    </>
  );
}

export default KickPredictor;
